import { RoomId, roomId, StreamId, streamId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStreamDeleteEventDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomStreamDeleteEventDTO.validationSchema()
  );

  constructor(readonly data: RoomStreamDeleteEventDTORaw) {
    JsonSchemaValidator.assert(RoomStreamDeleteEventDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "streamId"],
      properties: {
        roomId,
        streamId
      },
      additionalProperties: false
    };
  }
}

export interface RoomStreamDeleteEventDTORaw {
  roomId: RoomId;
  streamId: StreamId;
}
